import { markets } from "application/constants/app-constants";
import { is, defaultTo, filter, isEmpty, forEach, map, pathOr, isNil } from "ramda";

export default function parseAvailableData(data) {
  return filter(v => v !== null, map(day => parseDays(day), pathOr([], ["availability"], data)));
}

function parseDays(dataDay) {
  if (dataDay.availableDay !== true || isEmpty(dataDay.availableStoreTime)) {
    return null;
  }
  return {
    day: dataDay.day,
    avaialableTime: map(newTime => newTime.hour, filter(time => time.freeSlots > 0, defaultTo([], dataDay.availableStoreTime))),
    sectionTime: getSectionTime(dataDay.availableStoreTime),
  }
}

function getSectionTime(availableStoreTime) {
  const result = {};
  forEach(a => {
    if (!isNil(a.storeSections) && !isEmpty(a.storeSections)) {
      forEach(s => {
         if (s.capacity > 0) {
          if(is(Array, result[s.section])) {
            result[s.section].push(a.hour);
          } else {
            result[s.section] = [a.hour];
          }
        }
      }, a.storeSections);
    }
  }, availableStoreTime);

  return result;
}